import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";

const withDebounced = (hocProps) => {
    const {
        debounce = 1000,
        propNames = [],
    } = hocProps;

    return (OriginalComponent) => (props) => {

        const [data, updateData] = useState({});

        const updateDataDebounce = useMemo(() => _.throttle(updateData, debounce), []);

        useEffect(() => {
            updateDataDebounce({
                ...propNames.reduce((acc, cur) => {
                    acc[cur] = props[cur]
                    return acc;
                }, {})
            });
        }, [props, updateDataDebounce]);

        return <OriginalComponent {...{
            ...props,
            ...propNames.reduce((acc, cur) => {
                acc[cur] = data[cur]
                return acc;
            }, {})
        }}/>
    }
}

export default withDebounced;
